document.addEventListener('DOMContentLoaded', function() {
  const ioCards = document.querySelectorAll('.io-corporate-content-card__container');

  const observerOptions = {
    root: null, 
    threshold: 0.1, 
    rootMargin: "0px"
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); 
      }
    });
  }, observerOptions);

  ioCards.forEach(card => {
    observer.observe(card);
  });
});